"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMWarningFlag = void 0;
var EMWarningFlag;
(function (EMWarningFlag) {
    EMWarningFlag["NO_LEAD"] = "EM has no lead";
    EMWarningFlag["NO_JIRA_ACCOUNT_ID"] = "EM has no Jira account Id";
    EMWarningFlag["NO_RACKSPACE_EMAIL"] = "No rackspace.com email domain";
    EMWarningFlag["NO_ONICA_EMAIL"] = "No onica.com email domain";
})(EMWarningFlag || (exports.EMWarningFlag = EMWarningFlag = {}));
//# sourceMappingURL=EMWarningFlag.js.map